import * as actionTypes from './actionTypes';

export const getFlowActionsStart = () => {
    return {
        type: actionTypes.GET_FLOWACTIONS_START
    };
};

export const getFlowActionsSuccess = (actions) => {
    return {
        type: actionTypes.GET_FLOWACTIONS_SUCCESS,
        actions: actions
    };
};

export const getFlowActionsFail = (error) => {
    return {
        type: actionTypes.GET_FLOWACTIONS_FAIL,
        error: error
    };
};

export const getFlowActions = () => {
    return dispatch => {
        dispatch(getFlowActionsStart());

        //just dummy
        const delay = t => new Promise(resolve => setTimeout(resolve, t));
        
        delay(4000).then(() => {
                let dummy = [{
                    actionId: 123,
                    title: '1. Aktion'
                }, 
                {
                    actionId: 143,
                    title: '2. Aktion'
                }, 
                {
                    actionId: 12,
                    title: '3. Aktion'
                }, 
                ]    
                dispatch(getFlowActionsSuccess(dummy));
            
        }).catch(res => {
     
            dispatch(getFlowActionsFail(res.msg));
        });      
    };
};